export default __webpack_public_path__ + "static/media/DSC_7425.be6894bb.jpg";